export const slugify = text => {
    const preservedUppercase = str => str.replace(/dazn/gi, match => match.toUpperCase());

    let slug = String(text)
        .normalize('NFKD')
        .trim()
        .toLowerCase()
        .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
        .replace(/[''"""']/g, '') // Remove quotes
        .replace(/\//g, '-') // Replace forward slashes with hyphens
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/[^\p{L}\p{N}-]+/gu, '') // Remove non-letter/number/dash
        .replace(/--+/g, '-') // Replace multiple dashes
        .replace(/^-+|-+$/g, ''); // Trim dashes

    slug = preservedUppercase(slug);

    return slug;
};

export const handleLiveChatClick = () => {
    console.log('Opening chatbot...');
    window.YellowMessengerPlugin?.openBot();
};

export function stripInlineStyles(htmlString) {
    return removeInlineBackground(htmlString);
}

function removeInlineBackground(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    doc.querySelectorAll('[style]').forEach(el => {
        const style = el.getAttribute('style');

        // Remove background or background-color definitions (any whitespace/case)
        const cleanedStyle = style
            .replace(/background\s*:\s*[^;]+;?/gi, '')
            .replace(/background-color\s*:\s*[^;]+;?/gi, '');

        // If any style remains, set it back, otherwise remove the attribute
        if (cleanedStyle.trim()) {
            el.setAttribute('style', cleanedStyle.trim());
        } else {
            el.removeAttribute('style');
        }
    });

    return doc.body.innerHTML;
}

export function checkTotalArticlesInSection(sectionLevel1) {
    // check if at least 1 section level 2 has non empty array of articles

    return (
        sectionLevel1?.child_sections?.reduce(
            (prev, sectionLevel2) => prev + sectionLevel2?.articles?.length,
            sectionLevel1.child_sections[0]?.articles?.length,
        ) > 0
    );
}

export function recordAnalytics(event = '') {}

export function removeNonEnglishArticleSummary(text = '') {
    const nonEnglishCharRegex = /[àáâãäåçèéêëìíîïñòóôõöùúûüÿœæ]/i;
    const englishStopWords = [
        'the',
        'and',
        'is',
        'are',
        'to',
        'of',
        'in',
        'for',
        'with',
        'on',
        'this',
    ];

    if (!text.trim()) return false;

    if (nonEnglishCharRegex.test(text)) return false;

    const lower = text.toLowerCase();
    return englishStopWords.some(word => lower.includes(` ${word} `));
}

export function devModeRouting(isDevMode, articleId, categoryName, sectionName) {
    return isDevMode
        ? // dev mode = true, will take user to article for testing
          `/article/${articleId}`
        : // dev mode = false, will take user to start of trouble shooting
          `/${slugify(categoryName)}/${slugify(sectionName)}`;
}

export function windowScrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
}

export const excludeCategorisFromSearchResults = [
    'alert',
    'troubleshooting'
];
